var render = function render(){var _vm=this,_c=_vm._self._c;return _c('materials-scanner',{ref:"materialsScanner",on:{"screen-closed":() => _vm.$emit('closed')}})
}
var staticRenderFns = []

export { render, staticRenderFns }